import * as React from 'react';
import {
  AppBar
} from 'react-admin';
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { PrecisionManufacturing } from '@mui/icons-material';
import ProfileSection from './ProfileSection';
import { Link } from 'react-router-dom';
import Color from '../color/Color';

const CustomAppBar = (props) => {
  const isLargeEnough = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  return (
    <AppBar
      {...props}
      color="inherit"
      elevation={0}
      userMenu={<ProfileSection />}
    >
      {isLargeEnough && (
        <Button 
          component={Link} to="/dashboard"
          sx={{
            color: 'transparent'
          }}
        >
          <PrecisionManufacturing sx={{ fontSize: '48px', color: Color.Main }} />
          <Typography
            variant="h2"
            bottom="12px"
          >
            Merchant Portal
          </Typography>
        </Button>
      )}
      {isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}
    </AppBar>
  );
};

export default CustomAppBar;
